import { render, staticRenderFns } from "./MyAppointments.vue?vue&type=template&id=215ac2a2&scoped=true&"
import script from "./MyAppointments.vue?vue&type=script&lang=js&"
export * from "./MyAppointments.vue?vue&type=script&lang=js&"
import style0 from "./MyAppointments.vue?vue&type=style&index=0&id=215ac2a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ac2a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer})
